import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getCampaignElementById,
  getCampaignElementTypes
} from '../../redux/modules/campaignLandingPage';
import CampaignQuestionContainer from './CampaignQuestionContainer';
import TextInput from './TextInput';
import TextAreaInput from './TextAreaInput';
import RichText from './RichText';
import ImageElement from './ImageElement';
import VideoElement from './VideoElement';
import CheckboxElement from './CheckboxElement';
import FileUploadInput from './FileUploadInput';
import SignatureElement from './SignatureElement';

import CampaignRatingInput from '../../vp-ui/components/CampaignRatingInput/CampaignRatingInput';
import MultipleChoice from '../../vp-ui/components/MultipleChoice/MultipleChoice';

const ElementFacade = (props) => {
  switch (props.elementTypesMap[props.element.elementTypeId]) {
    case 'Video Response': {
      return <CampaignQuestionContainer {...props} />;
    }

    case 'File Attachment': {
      return <FileUploadInput {...props} />;
    }

    case 'Short Answer': {
      return <TextInput {...props} />;
    }

    case 'Written Response': {
      return <TextAreaInput {...props} />;
    }

    case 'Rich Text': {
      return <RichText {...props} />;
    }

    case 'Image': {
      return <ImageElement {...props} />;
    }

    case 'Video Message': {
      return <VideoElement {...props} />;
    }

    case 'Signature': {
      return <SignatureElement {...props} />;
    }

    case 'Checkbox': {
      return <CheckboxElement {...props} />;
    }

    case 'Rating': {
      return <CampaignRatingInput {...props} />;
    }

    case 'Multiple Choice': {
      return <MultipleChoice {...props} />;
    }

    default:
      return null;
  }
};

ElementFacade.propTypes = {
  elementTypesMap: PropTypes.object,
  element: PropTypes.object
};

function mapStateToProps(state, ownProps) {
  return {
    elementTypesMap: getCampaignElementTypes(state),
    element: getCampaignElementById(state, ownProps.qid)
  };
}

export default connect(mapStateToProps)(ElementFacade);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/ElementFacade.jsx